import {Box, BoxProps, Flex, HStack, Icon, LinkProps, useDisclosure} from "@chakra-ui/react";
import {ChevronDownIcon} from "@heroicons/react/20/solid";
import {LeftNav, Nav, NavLink} from "./Common";
import RegisterButton from "../CTAButton";
import {Page} from "./links";

const StyledNavLink = (props: LinkProps) => <NavLink display="flex" alignItems="center" gap={1.5} {...props} />;

const NavTab = ({page}: LinkProps & {page: Page}) => {
  const {open, onOpen, onClose} = useDisclosure();
  const mouseOutPadding = 4;

  return page.type === "dropdown" ? (
    <Flex position="relative" onMouseOver={onOpen} onMouseOut={onClose}>
      <StyledNavLink bg={open ? "white" : undefined} color={open ? "blue.500" : "white"} href={page.href ?? "#"}>
        {page.text}
        <Icon size="sm" mt="1px">
          <ChevronDownIcon />
        </Icon>
      </StyledNavLink>
      <Box
        p={mouseOutPadding}
        pt={mouseOutPadding - 2}
        mx={-mouseOutPadding}
        mt={4 - mouseOutPadding}
        w={page.w ?? "400px"}
        position="absolute"
        left="0"
        top="100%"
        display={open ? "block" : "none"}
      >
        <page.dropdown open={open} shadow="md" />
      </Box>
    </Flex>
  ) : (
    <NavLink href={page.href}>{page.text}</NavLink>
  );
};

const RightNav = () => (
  <HStack align="center" gap={4}>
    <NavLink href="https://app.platformed.com">Sign in</NavLink>
    <RegisterButton href="/contact" />
  </HStack>
);

const DesktopNav = ({links, light, ...props}: {links: Page[]; light?: boolean} & BoxProps) => (
  <Nav light={light} {...props}>
    <LeftNav>
      {links.map((page, i) => (
        <NavTab key={i} page={page} />
      ))}
    </LeftNav>
    <RightNav />
  </Nav>
);

export default DesktopNav;
